import { useContext } from 'react';
import { ErrorApisObject, ItemList, ListOptions, SelectOptions } from '../ApisForm.model';
import { OptionsOtherDocuments } from '../components/DocumentationRequired/DocumentationRequired.model';
import { ApisFormContext } from '../ApisForm.utils';
import { ApisError } from '../ApisForm.constants';

type UseDocumentationRequiredProps = {
	isInfant?: boolean;
};

const getOptionsOptionalDocuments = (options: ListOptions): OptionsOtherDocuments => {
	const optionsResponse: OptionsOtherDocuments = {
		showDivider: false,
		defaultVisa: { visaDocsTypes: { label: 'Visa', value: 'VISA' }, countries: options.countries as SelectOptions[] }
	};
	if (options.visaDocsTypes) {
		optionsResponse.visa = {
			visaDocsTypes: options.visaDocsTypes,
			countries: options.countries as SelectOptions[]
		};
	}

	if (options.otherDocsTypes) {
		optionsResponse.others = {
			otherDocsTypes: options.otherDocsTypes,
			countries: options.countries as SelectOptions[]
		};
	}

	optionsResponse.showDivider = optionsResponse.visa !== undefined || optionsResponse.others !== undefined;

	return optionsResponse;
};

const getSelectOptions = (type: ItemList): SelectOptions => {
	return {
		value: type.code,
		label: type.description
	};
};

const findErrorVisa = (apisErrors: ErrorApisObject[]) => {
	let isErrorVisa = false;
	apisErrors.forEach((error) => {
		if (!isErrorVisa && error.code === ApisError.TM_VISA_REQUIRED) isErrorVisa = true;
	});

	return isErrorVisa;
};

export const useDocumentationRequired = ({ isInfant = false }: UseDocumentationRequiredProps) => {
	const { listOptions, documentationRequired, infant, isPrivacyStatement, id, apisErrors } =
		useContext(ApisFormContext);
	const minDate = new Date();
	const maxDate = new Date(minDate.setFullYear(minDate.getFullYear() + 10));
	const isOptional = true;
	const destination: string = isPrivacyStatement ? 'USA' : '';
	const modelInfant = isInfant ? infant?.documentationRequired : documentationRequired;

	if (Array.isArray(modelInfant?.other)) {
		listOptions.otherDocsTypes = [];
		for (let i = 0; i < modelInfant.other.length; i++) {
			const doc = modelInfant.other[i];
			const type = doc.type as ItemList;
			if (type.code.toUpperCase() === 'VISA') listOptions.visaDocsTypes = getSelectOptions(type);
			else listOptions.otherDocsTypes.push(getSelectOptions(type));
		}

		if (listOptions.otherDocsTypes.length === 0) listOptions.otherDocsTypes = undefined;
	}

	const existErrorVisa = findErrorVisa(apisErrors ?? []);

	return {
		id,
		isOptional,
		minDate,
		maxDate,
		destination,
		listOptions,
		documentationRequired: modelInfant,
		getOptionsOptionalDocuments,
		existErrorVisa
	};
};
